import { slavesConstants } from '../constants/slaves';
import { categoriesConstants } from '../constants/categories';

const initialState = {
  wallets: [],
  balance: [],
  // ==========
  payment: {},
  paymentsData: {
    items: [],
    count: 0,
  },
  paymentOrders: {
    items: [],
    count: 0,
  },
  details: {},
  settings: {},
  // dictionaties
  offers: [],
  streams: {},
  categories: [],
  // =========
  slaveSites: [],
  slaveSiteSettings: [],
  dict: {},
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case categoriesConstants.SET_CATEGORIES_LIST_REQUEST:
      return {
        ...state,
        categories: [],
      };
    case categoriesConstants.SET_CATEGORIES_LIST_SUCCESS:
      return {
        ...state,
        categories: action.data,
      };
    case slavesConstants.SET_STATS_REQUEST:
      return {
        ...state,
        ids: [],
      };
    case slavesConstants.SET_STATS_SUCCESS:
      return {
        ...state,
        ids: action.data,
      };
    case slavesConstants.DELETE_SLAVE_SUCCESS:
      return {
        ...state,
        ids: state.ids.filter(({ id }) => id !== action.id),
      };
    case slavesConstants.SET_SLAVE_WALLETS_SUCCESS:
      return {
        ...state,
        wallets: action.wallets,
      };
    case slavesConstants.SET_SLAVE_BALANCE_SUCCESS:
      return {
        ...state,
        balance: action.balance,
      };
    case slavesConstants.SET_SLAVE_PAYMENT_ORDERS_SUCCESS:
      return {
        ...state,
        paymentOrders: {
          items: action.paymentOrders,
          count: action.count,
        },
      };
    case slavesConstants.SET_SLAVE_PAYMENTS_DATA_SUCCESS:
      return {
        ...state,
        paymentsData: {
          items: action.data,
          count: action.count,
        },
      };

    case slavesConstants.SET_SLAVE_HOLD_DETAILS_SUCCESS:
      return {
        ...state,
        details: {
          ...state.details,
          ...action.details,
        },
      };
    case slavesConstants.SET_SLAVE_HOLD_DETAILS_SETTINGS_SUCCESS:
      return {
        ...state,
        settings: {
          ...state.settings,
          ...action.settings,
        },
      };
    case slavesConstants.SET_SLAVE_OFFERS_LIST_SUCCESS:
      return {
        ...state,
        offers: action.offers,
      };
    case slavesConstants.SET_SLAVE_STREAMS_SUCCESS:
      return {
        ...state,
        streams: {
          streams: action.streams,
          count: action.count,
          settings: action.settings,
        },
      };
    case slavesConstants.SET_SLAVE_SITE_SETTINGS_SUCCESS:
      return {
        ...state,
        slaveSiteSettings: action.settings,
      };
    case slavesConstants.SET_SLAVE_SITES_SUCCESS:
      return {
        ...state,
        slaveSites: action.sites,
      };
    case slavesConstants.SET_SLAVE_STATS_DICTIONARY_SUCCESS:
      const type = Object.keys(action.dictionary)[0];
      let dictionary;

      if (type && state.dict[type]) {
        dictionary = { [type]: [...state.dict[type]] };
        action.dictionary[type].forEach((el) => {
          const stateItem = dictionary[type].find((item) => item.id === el.id);
          if (!stateItem) {
            dictionary[type].push(el);
          }
        });
      } else {
        dictionary = { ...action.dictionary };
      }
      return {
        ...state,
        dict: type ? { ...state.dict, ...dictionary } : state.dict,
      };
    case slavesConstants.SET_SLAVE_HOLD_DETAILS_SUCCESS:
      return {
        ...state,
        details: {
          ...state.details,
          ...action.details,
        },
      };

    case slavesConstants.SET_SLAVE_HOLD_DETAILS_SETTINGS_SUCCESS:
      return {
        ...state,
        settings: {
          ...state.settings,
          ...action.settings,
        },
      };
    default:
      return state;
  }
};
